var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "booking-format-address" },
    [
      _c(
        "el-form-item",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.notSeaHouseChannelOrWseChannel,
              expression: "notSeaHouseChannelOrWseChannel"
            }
          ],
          attrs: { label: _vm.$t("SeaExport.consignorCode") }
        },
        [
          _c(
            "special-character-tip",
            { attrs: { texts: _vm.specialCharCheck.shipperShortCode } },
            [
              _c("cargo-input", {
                class: _vm.importDifferenceField.shipperShortCode
                  ? "red-border"
                  : "",
                attrs: {
                  placeholder:
                    (_vm.isSeaHouseChannel ||
                      _vm.isWseChannel ||
                      _vm.isRongeTong) &&
                    _vm.isEditing
                      ? _vm.$t("CargoMsg.Cargo_pleaseEnterTheEnterpriseCode")
                      : "",
                  "auto-uppercase": true,
                  "auto-half-word": true
                },
                model: {
                  value: _vm.manifestInfo.shipperShortCode,
                  callback: function($$v) {
                    _vm.$set(_vm.manifestInfo, "shipperShortCode", $$v)
                  },
                  expression: "manifestInfo.shipperShortCode"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.notSeaHouseChannelOrWseChannel,
              expression: "notSeaHouseChannelOrWseChannel"
            }
          ],
          staticClass: "label-right",
          attrs: { label: "+" }
        },
        [
          _c(
            "special-character-tip",
            { attrs: { texts: _vm.specialCharCheck.shipperEnterpriseCode } },
            [
              _c("cargo-input", {
                class: _vm.importDifferenceField.shipperEnterpriseCode
                  ? "red-border"
                  : "",
                attrs: { "auto-uppercase": true, "auto-half-word": true },
                model: {
                  value: _vm.manifestInfo.shipperEnterpriseCode,
                  callback: function($$v) {
                    _vm.$set(_vm.manifestInfo, "shipperEnterpriseCode", $$v)
                  },
                  expression: "manifestInfo.shipperEnterpriseCode"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          ref: "shipperEnterpriseName",
          class: _vm.labelStyle,
          attrs: {
            label: _vm.$t("SeaExport.consignorName"),
            prop: "shipperEnterpriseName",
            rules: [
              {
                validator: _vm.validatorShipperEnterpriseName,
                trigger: "blur",
                required: true
              }
            ]
          }
        },
        [
          _c(
            "el-tooltip",
            {
              attrs: {
                content:
                  _vm.isSeaHouseChannel || _vm.isWseChannel || _vm.isRongeTong
                    ? _vm.$t("CargoMsg.Cargo_ShipperEnterpriseNameTip2")
                    : "",
                placement: "bottom",
                effect: "light"
              }
            },
            [
              _c(
                "special-character-tip",
                {
                  attrs: { texts: _vm.specialCharCheck.shipperEnterpriseName }
                },
                [
                  !_vm.showCombinedManifest
                    ? _c("cargo-input", {
                        class: _vm.importDifferenceField.shipperEnterpriseName
                          ? "red-border"
                          : "",
                        attrs: {
                          placeholder: _vm.addressTip,
                          "auto-uppercase": true,
                          "auto-half-word": true,
                          trim:
                            _vm.isSeaHouseChannel ||
                            _vm.isWseChannel ||
                            _vm.isRongeTong
                        },
                        model: {
                          value: _vm.manifestInfo.shipperEnterpriseName,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.manifestInfo,
                              "shipperEnterpriseName",
                              $$v
                            )
                          },
                          expression: "manifestInfo.shipperEnterpriseName"
                        }
                      })
                    : _c("cargo-rich-textarea", {
                        class: _vm.importDifferenceField.shipperEnterpriseName
                          ? "red-border"
                          : "",
                        staticStyle: {
                          height: "70px",
                          "min-height": "70px",
                          width: "180px"
                        },
                        attrs: {
                          no: "shipperEnterpriseName",
                          "text-chars": 0,
                          "warning-count": -1,
                          "wrap-symbol": "n",
                          "auto-half-word": "",
                          "auto-uppercase": "",
                          disabled: !_vm.isEditing,
                          "is-trim":
                            _vm.isSeaHouseChannel ||
                            _vm.isWseChannel ||
                            _vm.isRongeTong
                        },
                        nativeOn: {
                          dblclick: function($event) {
                            _vm.showAdvanceTextDialog(
                              _vm.$t("SeaExport.consignorName"),
                              _vm.manifestInfo.shipperEnterpriseName,
                              function(val) {
                                _vm.manifestInfo.shipperEnterpriseName = val
                              }
                            )
                          }
                        },
                        model: {
                          value: _vm.manifestInfo.shipperEnterpriseName,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.manifestInfo,
                              "shipperEnterpriseName",
                              $$v
                            )
                          },
                          expression: "manifestInfo.shipperEnterpriseName"
                        }
                      })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          ref: "shipperAddress",
          class: _vm.labelStyle,
          attrs: {
            label: _vm.$t("SeaExport.consignorDetailAddress"),
            prop: "shipperAddress",
            rules: [
              {
                validator: _vm.validatorShipperAddress,
                trigger: "blur",
                required: true
              }
            ]
          }
        },
        [
          _c(
            "special-character-tip",
            { attrs: { texts: _vm.specialCharCheck.shipperAddress } },
            [
              !_vm.showCombinedManifest
                ? _c("cargo-input", {
                    class: _vm.importDifferenceField.shipperAddress
                      ? "red-border"
                      : "",
                    attrs: {
                      placeholder: _vm.addressTip2,
                      "auto-uppercase": true,
                      "auto-half-word": true,
                      trim:
                        _vm.isSeaHouseChannel ||
                        _vm.isWseChannel ||
                        _vm.isRongeTong
                    },
                    model: {
                      value: _vm.manifestInfo.shipperAddress,
                      callback: function($$v) {
                        _vm.$set(_vm.manifestInfo, "shipperAddress", $$v)
                      },
                      expression: "manifestInfo.shipperAddress"
                    }
                  })
                : _c("cargo-rich-textarea", {
                    ref: "cargoTextarea1",
                    class: _vm.importDifferenceField.shipperAddress
                      ? "red-border"
                      : "",
                    staticStyle: { height: "110px", width: "180px" },
                    attrs: {
                      no: "shipperAddress",
                      "text-chars": 0,
                      "warning-count": -1,
                      "wrap-symbol": "n",
                      "auto-half-word": "",
                      "auto-uppercase": "",
                      disabled: !_vm.isEditing,
                      "is-trim":
                        _vm.isSeaHouseChannel ||
                        _vm.isWseChannel ||
                        _vm.isRongeTong
                    },
                    nativeOn: {
                      dblclick: function($event) {
                        _vm.showAdvanceTextDialog(
                          _vm.$t("SeaExport.consignorDetailAddress"),
                          _vm.manifestInfo.shipperAddress,
                          function(val) {
                            _vm.manifestInfo.shipperAddress = val
                          }
                        )
                      }
                    },
                    model: {
                      value: _vm.manifestInfo.shipperAddress,
                      callback: function($$v) {
                        _vm.$set(_vm.manifestInfo, "shipperAddress", $$v)
                      },
                      expression: "manifestInfo.shipperAddress"
                    }
                  })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          staticClass: "auto-width",
          class:
            _vm.manifestInfo.shipperContactsType === 0 ? _vm.labelStyle : "mag",
          staticStyle: { display: "inline-block" },
          attrs: { "label-width": "0" }
        },
        [
          _c(
            "div",
            { staticStyle: { display: "flex" } },
            [
              _c(
                "el-select",
                {
                  class: _vm.importDifferenceField.shipperContactsType
                    ? "require-select red-border"
                    : "require-select",
                  staticStyle: { width: "146px" },
                  on: { change: _vm.changeContactsType },
                  model: {
                    value: _vm.manifestInfo.shipperContactsType,
                    callback: function($$v) {
                      _vm.$set(_vm.manifestInfo, "shipperContactsType", $$v)
                    },
                    expression: "manifestInfo.shipperContactsType"
                  }
                },
                [
                  _c("el-option", {
                    attrs: {
                      label: _vm.$t("SeaExport.consignorPhone"),
                      value: 0
                    }
                  }),
                  _c("el-option", {
                    attrs: {
                      label: _vm.$t("SeaExport.consignorEmail"),
                      value: 1
                    }
                  }),
                  _c("el-option", {
                    attrs: {
                      label: _vm.$t("SeaExport.consignorRelexNumber"),
                      value: 2
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _c(
        "el-form-item",
        {
          ref: "notifyPhone",
          staticClass: "auto-width",
          class:
            _vm.manifestInfo.shipperContactsType === 0 ? _vm.labelStyle : "mag",
          staticStyle: { display: "inline-block" },
          attrs: {
            "label-width": "0",
            prop: "shipperContacts",
            rules: [{ validator: _vm.validatorShipperPhone, trigger: "blur" }]
          }
        },
        [
          _c(
            "special-character-tip",
            { attrs: { texts: _vm.specialCharCheck.shipperContacts } },
            [
              _c(
                "el-tooltip",
                {
                  attrs: {
                    content:
                      _vm.manifestInfo.shipperContactsType === 0
                        ? _vm.$t("CargoMsg.Cargo_pleaseEnterAPhoneNumber")
                        : "",
                    placement: "bottom",
                    effect: "light"
                  }
                },
                [
                  _c("cargo-input", {
                    class: _vm.importDifferenceField.shipperContacts
                      ? "red-border"
                      : "",
                    staticStyle: { width: "174px", "margin-left": "4px" },
                    attrs: {
                      "auto-uppercase": true,
                      "auto-half-word": true,
                      placeholder:
                        _vm.manifestInfo.shipperContactsType === 0 &&
                        (_vm.isSeaHouseChannel ||
                          _vm.isWseChannel ||
                          _vm.isRongeTong) &&
                        _vm.isEditing
                          ? _vm.$t("CargoMsg.Cargo_pleaseEnterAPhoneNumber")
                          : ""
                    },
                    model: {
                      value: _vm.manifestInfo.shipperContacts,
                      callback: function($$v) {
                        _vm.$set(_vm.manifestInfo, "shipperContacts", $$v)
                      },
                      expression: "manifestInfo.shipperContacts"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value:
                !(
                  _vm.isWseChannel &&
                  _vm.manifestInfo.portOfLoading === "CNTAO" &&
                  _vm.manifestInfo.thirdPartyCarrier === "OOCL"
                ) &&
                !_vm.isSeaHouseChannel && !_vm.isWseChannel && !_vm.isRongeTong,
              expression:
                "!(isWseChannel && manifestInfo.portOfLoading === 'CNTAO' && manifestInfo.thirdPartyCarrier === 'OOCL') && (!isSeaHouseChannel && !isWseChannel && !isRongeTong) "
            }
          ],
          attrs: { label: _vm.$t("SeaExport.cityName") }
        },
        [
          _c(
            "special-character-tip",
            { attrs: { texts: _vm.specialCharCheck.shipperCityName } },
            [
              _c("cargo-input", {
                class: _vm.importDifferenceField.shipperCityName
                  ? "red-border"
                  : "",
                attrs: { "auto-uppercase": true, "auto-half-word": true },
                model: {
                  value: _vm.manifestInfo.shipperCityName,
                  callback: function($$v) {
                    _vm.$set(_vm.manifestInfo, "shipperCityName", $$v)
                  },
                  expression: "manifestInfo.shipperCityName"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.notSeaHouseChannelOrWseChannel,
              expression: "notSeaHouseChannelOrWseChannel"
            }
          ],
          attrs: { label: _vm.$t("SeaExport.provinceCode") }
        },
        [
          _c(
            "special-character-tip",
            { attrs: { texts: _vm.specialCharCheck.shipperProvinceCode } },
            [
              _c("cargo-input", {
                class: _vm.importDifferenceField.shipperProvinceCode
                  ? "red-border"
                  : "",
                attrs: { "auto-uppercase": true, "auto-half-word": true },
                model: {
                  value: _vm.manifestInfo.shipperProvinceCode,
                  callback: function($$v) {
                    _vm.$set(_vm.manifestInfo, "shipperProvinceCode", $$v)
                  },
                  expression: "manifestInfo.shipperProvinceCode"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.notSeaHouseChannelOrWseChannel,
              expression: "notSeaHouseChannelOrWseChannel"
            }
          ],
          attrs: { label: _vm.$t("SeaExport.provinceName") }
        },
        [
          _c(
            "special-character-tip",
            { attrs: { texts: _vm.specialCharCheck.shipperProvinceName } },
            [
              _c("cargo-input", {
                class: _vm.importDifferenceField.shipperProvinceName
                  ? "red-border"
                  : "",
                attrs: { "auto-uppercase": true, "auto-half-word": true },
                model: {
                  value: _vm.manifestInfo.shipperProvinceName,
                  callback: function($$v) {
                    _vm.$set(_vm.manifestInfo, "shipperProvinceName", $$v)
                  },
                  expression: "manifestInfo.shipperProvinceName"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.notSeaHouseChannelOrWseChannel,
              expression: "notSeaHouseChannelOrWseChannel"
            }
          ],
          attrs: { label: _vm.$t("SeaExport.ZipCode") }
        },
        [
          _c(
            "special-character-tip",
            { attrs: { texts: _vm.specialCharCheck.shipperZipCode } },
            [
              _c("cargo-input", {
                class: _vm.importDifferenceField.shipperZipCode
                  ? "red-border"
                  : "",
                attrs: { "auto-uppercase": true, "auto-half-word": true },
                model: {
                  value: _vm.manifestInfo.shipperZipCode,
                  callback: function($$v) {
                    _vm.$set(_vm.manifestInfo, "shipperZipCode", $$v)
                  },
                  expression: "manifestInfo.shipperZipCode"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          ref: "shipperCountryCode",
          class: _vm.labelStyle,
          attrs: {
            label: _vm.$t("CargoMsg.Cargo_CountryRegionCode"),
            prop: "shipperCountryCode",
            rules: [
              { validator: _vm.validatorShipperCountryCode, trigger: "change" }
            ]
          }
        },
        [
          _c(
            "el-tooltip",
            {
              attrs: {
                content: _vm.$t("CargoMsg.Cargo_pleaseSelectACountryCode"),
                placement: "bottom",
                effect: "light"
              }
            },
            [
              _c(
                "special-character-tip",
                { attrs: { texts: _vm.specialCharCheck.shipperCountryCode } },
                [
                  !_vm.isSeaHouseChannel &&
                  !_vm.isWseChannel &&
                  !_vm.isRongeTong
                    ? _c("cargo-input", {
                        class: _vm.importDifferenceField.shipperCountryCode
                          ? "red-border"
                          : "",
                        attrs: {
                          "auto-uppercase": true,
                          "auto-half-word": true
                        },
                        model: {
                          value: _vm.manifestInfo.shipperCountryCode,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.manifestInfo,
                              "shipperCountryCode",
                              $$v
                            )
                          },
                          expression: "manifestInfo.shipperCountryCode"
                        }
                      })
                    : _c("cargo-advance-select", {
                        class: _vm.importDifferenceField.shipperCountryCode
                          ? "red-border"
                          : "",
                        attrs: {
                          "static-options": _vm.countryList || [],
                          cache: false,
                          "default-value": _vm.manifestInfo.shipperCountryCode,
                          filterable: "",
                          clearable: "",
                          "filter-tag-names": ["name", "code", "chineseName"],
                          "custom-label": function(item) {
                            return "[" + item.code + "]" + item.name
                          },
                          "tag-name": "name",
                          "tag-value": "code",
                          placeholder: _vm.$t(
                            "CargoMsg.Cargo_pleaseSelectACountryCode"
                          )
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.manifestInfo.shipperCountryCode = p.value
                          }
                        }
                      })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.notSeaHouseChannelOrWseChannel,
              expression: "notSeaHouseChannelOrWseChannel"
            }
          ],
          attrs: { label: _vm.$t("SeaExport.aeoEnterpriseCode") }
        },
        [
          _c(
            "special-character-tip",
            { attrs: { texts: _vm.specialCharCheck.shipperAeoEnterpriseCode } },
            [
              _c("cargo-input", {
                attrs: { "auto-uppercase": true, "auto-half-word": true },
                model: {
                  value: _vm.manifestInfo.shipperAeoEnterpriseCode,
                  callback: function($$v) {
                    _vm.$set(_vm.manifestInfo, "shipperAeoEnterpriseCode", $$v)
                  },
                  expression: "manifestInfo.shipperAeoEnterpriseCode"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value:
                _vm.isWseChannel &&
                _vm.manifestInfo.portOfLoading === "CNTAO" &&
                _vm.manifestInfo.thirdPartyCarrier === "OOCL",
              expression:
                "isWseChannel && manifestInfo.portOfLoading === 'CNTAO' && manifestInfo.thirdPartyCarrier === 'OOCL'"
            }
          ],
          staticClass: "required-label",
          attrs: {
            prop: "shipperCityName",
            rules: [
              { validator: _vm.validatorShipperCityName, trigger: "blur" }
            ],
            label: _vm.$t("SeaExport.consignorCityName")
          }
        },
        [
          _c(
            "el-tooltip",
            {
              attrs: {
                content: _vm.$t("SeaExport.ShipperCityCannotBeBlank"),
                placement: "bottom",
                effect: "light"
              }
            },
            [
              _c(
                "special-character-tip",
                { attrs: { texts: _vm.specialCharCheck.shipperCityName } },
                [
                  _c("cargo-input", {
                    attrs: {
                      placeholder:
                        _vm.isWseChannel && _vm.isEditing
                          ? _vm.$t("SeaExport.ShipperCityCannotBeBlank")
                          : "",
                      "auto-uppercase": true,
                      "auto-half-word": true
                    },
                    model: {
                      value: _vm.manifestInfo.shipperCityName,
                      callback: function($$v) {
                        _vm.$set(_vm.manifestInfo, "shipperCityName", $$v)
                      },
                      expression: "manifestInfo.shipperCityName"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            no: "advanceTextDialog",
            visible: _vm.advanceTextDialog.visible,
            title: _vm.advanceTextDialog.title,
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            width: "600px"
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.advanceTextDialog, "visible", $event)
            },
            close: _vm.closeAdvanceText
          }
        },
        [
          _c("cargo-rich-textarea", {
            ref: "advanceTextDialogTextarea",
            staticStyle: { height: "320px" },
            attrs: {
              no: "advanceTextDialogTextarea",
              disabled: !_vm.isEditing,
              "text-chars": _vm.advanceTextDialog.formatObj.maxChar,
              "warning-count": _vm.advanceTextDialog.formatObj.warningCount,
              "auto-half-word": _vm.advanceTextDialog.formatObj.autoHalfWord,
              "auto-uppercase": _vm.advanceTextDialog.formatObj.autoUppercase
            },
            model: {
              value: _vm.advanceTextDialog.value,
              callback: function($$v) {
                _vm.$set(_vm.advanceTextDialog, "value", $$v)
              },
              expression: "advanceTextDialog.value"
            }
          }),
          _c("span", { attrs: { slot: "footer" }, slot: "footer" }, [
            _c(
              "button",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isEditing,
                    expression: "isEditing"
                  }
                ],
                staticClass: "el-button el-button--default el-button--mini",
                attrs: { no: "advanceTextDialogConfirm", type: "button" },
                on: { click: _vm.finishAdvanceText }
              },
              [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
            ),
            _c(
              "button",
              {
                staticClass: "el-button el-button--default el-button--mini",
                attrs: { type: "button", no: "advanceTextDialogClose" },
                on: {
                  click: function($event) {
                    _vm.advanceTextDialog.visible = false
                    _vm.closeAdvanceText()
                  }
                }
              },
              [_vm._v(_vm._s(_vm.$t("common.btn.close")))]
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }